import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import ButtonIcon from '../Button/ButtonIcon';

interface ModalCloseButtonProps {
  sticky?: boolean;
  onClick?: () => void;
  className?: string;
}

const Layout = styled.div<Partial<ModalCloseButtonProps>>`
  position: absolute;
  top: ${toRem(12)};
  right: ${toRem(12)};
  z-index: ${theme.zIndex.modal + 4};
  flex-flow: row nowrap;
  justify-content: flex-end;
  width: 100%;
  height: 0;
  overflow: visible;

  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: ${toRem(0)};
      right: ${toRem(0)};
    `}
`;

const StyledButtonIcon = styled(ButtonIcon)<Partial<ModalCloseButtonProps>>`
  position: relative;
  z-index: ${theme.zIndex.modal + 5};
  border: none;

  ${({ sticky }) =>
    sticky &&
    css`
      transform: translateX(0) translateY(${toRem(22)});

      @media (min-width: ${theme.breakpoint.small}px) {
        transform: translateX(50%) translateY(${toRem(22)});
      }
    `}
`;

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ sticky, onClick, className, ...rest }) => (
  <Layout sticky={sticky} className={className} onClick={onClick}>
    <StyledButtonIcon sticky={sticky} label="Close Modal" icon="Close" type="button" appearance="secondary" size="small" dataCy="modal-close-btn" {...rest} />
  </Layout>
);

export default ModalCloseButton;
